/*
 * expandable creates the on click listener for .js-expandable elements.
 *
 * The on click listener toggles the 'is-active' class on itself and the other .js-expandable elements.
 *
 * Requires element with class 'js-expandable'.
 */

const expandable = () => {
  if ($('.js-expandable').length === 0) {
    return;
  }

  const isActiveClass = 'is-active';

  $('.js-expandable').on('click', function handleClick() {
    const $this = $(this);
    if ($this.hasClass(isActiveClass)) {
      $('.js-expandable').removeClass(isActiveClass);
    } else {
      $('.js-expandable').removeClass(isActiveClass);
      $this.addClass(isActiveClass);
    }
  });

  /* Get the js-expandable height elements on the expandable and find the .expandable-content to set the height. */
  function calculate() {
    $('.js-expandable-height').each(function iterator() {
      const h = $(this)
        .children('div')
        .height();
      /* Set the css-variable in the expandable.css to the specific height of every content block. */
      $(this).css('--context-height', `${h}px`);
    });
  }
  /* This is necessary for the function to work only when the height is set. Otherwise it will return value null */
  $(document).ready(() => {
    calculate();
  });

  $(window).resize(() => {
    calculate();
  });
};

export default expandable;
